<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="isOpen"
      max-width="500"
    >
      <v-card>
        <v-card-title
          class="headline text-md-center"
          primary-title
        >
          Resend User Data
        </v-card-title>

        <v-progress-linear
          v-if="isLoading"
          :indeterminate="true"
          class="ma-0"
        />

        <v-card-text light>
          <p><strong>User ID</strong>: <code>{{ userId }}</code></p>
          <p><v-divider /></p>
          <p>If incorrect, missing or outdated data is displayed in the User Cockpit.</p>
          <p>Click here to resend the following data to the cockpit:</p>
          <ul>
            <li>Digital Depot Accounts</li>
            <li>Settlements</li>
            <li>PAT Documents</li>
            <li>IRE Documents</li>
          </ul>
          <p>Are you sure you want to do that?</p>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="onToggleOpen"
          >
            cancel
          </v-btn>
          <v-btn
            :loading="isLoading"
            color="primary"
            flat
            @click="submit"
          >
            Resend
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'RecalculateUserDialog',
  components: {
  },
  props: {
    isOpen: Boolean,
    toggleOpen: {
      type: Function,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    error: null,
  }),
  methods: {
    onToggleOpen() {
      this.toggleOpen();
      this.error = null;
    },
    submit() {
      this.isLoading = true;

      const payload = {
        request_uuid: 'cockpit-write',
        user_id_filter: [this.userId.toString()],
      };

      this.$store.dispatch('strategyPushLatestState', payload);
      this.$store.dispatch('settlementPushLatestState', payload);
      this.$store.dispatch('patDocumentsPushLatestState', payload);
      this.$store.dispatch('ireDocumentsPushLatestState', payload);

      setTimeout(() => {
        this.onToggleOpen();
        this.isLoading = false;
      }, 1000);
    },
  },
};
</script>
<style lang="scss" />



// WEBPACK FOOTER //
// src/components/roboInvesting/dialogs/account/RecalculateUserDialog.vue